<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ resumoId > 0 ? "Editar" : "Adicionar" }} Resumo do Município
        </h2>

        <v-row>
          <v-col>
            <v-text-field
              label="Nome completo"
              name="Nome completo"
              type="text"
              v-model="resumo.nome"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Ordem"
              name="Ordem"
              type="number"
              v-model="resumo.ordem"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              label="Telefone"
              name="telefone"
              type="text"
              v-mask="['(##) ####-####', '(##) #####-####']"
              v-model="resumo.telefone"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-text-field
              label="Email"
              name="email"
              type="text"
              v-model="resumo.email"
              required
              :rules="emailRules"
              background-color="white"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <combobox-instituicao
              :filter="resumo"
              :rules="rules"
            ></combobox-instituicao>
          </v-col>
          <v-col v-if="resumo.instituicao === 'OUTRA'">
            <v-text-field
              label="Outra Instituição"
              name="outra"
              type="text"
              v-model="resumo.outraInstituicao"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row style="height: 103px">
          <v-col cols="1" v-if="previewImage">
            <img :src="previewImage" style="width: 100%; border-radius: 50%" />
          </v-col>
          <v-col class="file-names" cols="6">
            <span class="name" v-if="resumo.fileName">{{
              resumo.fileName
            }}</span>
            <v-file-input
              accept="image/jpg, image/jpeg, image/png"
              label="Imagem"
              prepend-icon="mdi-camera"
              v-model="resumo.foto"
              @change="onFileChange"
              :rules="rulesPhoto"
            >
            </v-file-input>
          </v-col>
          <v-col>
            <v-text-field
              label="Cargo/Função"
              name="cargo"
              type="text"
              v-model="resumo.cargo"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import { AppCityHeader } from "@/modules/city";
import { ComboboxInstituicao } from "@/components/combobox";
import { resumoMunicipioApi } from "@/apis";

export default {
  components: {
    AppCityHeader,
    ComboboxInstituicao,
  },
  data() {
    return {
      resumo: {},
      municipioId: this.$route.params.id,
      isEdit: false,
      resumoId: this.$route.params.resumoId,
      rules: [(v) => !!v || "Campo Obrigatório"],
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
      rulesOutras: [
        (v) => {
          if (this.resumo.instituicao === "OUTRA") {
            return "Campo Obrigatório";
          } else {
            return true;
          }
        },
      ],
      rulesPhoto: [
        (v) => {
          if (v) {
            if (v.size > 100000) {
              return "Foto maior que 100kb";
            }
          } else {
            return true;
          }
          return true;
        },
      ],
      previewImage: "",
    };
  },
  mounted() {
    if (this.resumoId > 0) {
      this.setLoading(true);
      resumoMunicipioApi
        .find(this.resumoId)
        .then(({ data }) => {
          this.resumo = data;

          if (!["MUNICIPIO", "SEBRAE"].includes(data.instituicao)) {
            this.resumo.outraInstituicao = this.resumo.instituicao;
            this.resumo.instituicao = "OUTRA";
          }
          this.previewImage = `data:image/png;base64,${this.resumo.foto}`;

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Governança");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(`/cidade/${this.municipioId}/resumo-municipio`);
    },
    onFileChange() {
      if (this.resumo.foto) {
        this.previewImage = URL.createObjectURL(this.resumo.foto);
        this.resumo.fileName = this.resumo.foto.name;
      } else {
        this.previewImage = null;
        this.resumo.fileName = null;
      }
    },
    async onSubmit() {
      const valid = await this.check();
      if (!valid) return;

      this.resumo = {
        ...this.resumo,
        instituicao:
          this.resumo.instituicao === "OUTRA"
            ? this.resumo.outraInstituicao
            : this.resumo.instituicao,
        municipioId: this.municipioId,
      };

      let formData = new FormData();

      formData.append("fotoForm", this.resumo.foto);
      formData.append("nome", this.resumo.nome);
      formData.append("ordem", this.resumo.ordem);
      formData.append("telefone", this.resumo.telefone);
      formData.append("email", this.resumo.email);
      formData.append("instituicao", this.resumo.instituicao);
      formData.append("municipioId", this.resumo.municipioId);
      formData.append("fileName", this.resumo.fileName);
      formData.append("cargo", this.resumo.cargo);

      if (this.resumoId > 0) {
        formData.append("resumoId", this.resumo.resumoId);
        resumoMunicipioApi
          .update(formData)
          .then(() => {
            this.$notification.success("Resumo Municipio editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Resumo Municipio");
            console.log("Erro no submit ", err);
          });
      } else {
        resumoMunicipioApi
          .create(formData)
          .then(() => {
            this.$notification.success("Resumo Municipio criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Resumo Municipio");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: end;
}

.file-names {
  position: relative;
  height: 103px;
}

.name {
  position: absolute;
  bottom: 44px;
  left: 46px;
  /* color: #000; */
  width: 62%;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  background: #fff;
}
</style>

<style>
#attendance-list .v-file-input__text {
  display: none;
}
</style>
